import { bindContent } from "./content/catalog"

/**
 * Which tiles are pieces of a WOODEN wall, and which piece, as the content's tilesets say: a tile
 * whose `woodenWall` property is 0-12 is a base piece (see woodenWallFootprint for what each one
 * blocks), 13 a cap. A wooden wall blocks only a strip of ground under its raised face, so bodies
 * can walk up beneath it; any other blocking wall tile blocks its whole cell. Being tile metadata, a
 * wall material drawn on new art keeps those footprints by marking its tiles, with no code change.
 */
let pieces = new Map<string, Map<number, number>>()

/** The `woodenWall` property of every tile of every tileset: tileset -> position -> piece. */
export const woodenWallPiecesOf = (mapTilesets: Record<string, any>): Map<string, Map<number, number>> => {
    const out = new Map<string, Map<number, number>>()
    Object.entries(mapTilesets || {}).forEach(([tilesetId, tileset]) => {
        ;(tileset?.tiles || []).forEach((tile: any) => (tile.properties || []).forEach((p: any) => {
            if (p.name !== "woodenWall" || !Number.isInteger(Number(p.value))) return
            if (!out.has(tilesetId)) out.set(tilesetId, new Map())
            out.get(tilesetId).set(tile.id, Number(p.value))
        }))
    })
    return out
}

bindContent(catalog => woodenWallPiecesOf(catalog.mapTilesets), next => { pieces = next })

/** The wooden wall piece a tile (0-based position in its tileset) is: 0-12 a base, 13 a cap, -1 none. */
export const woodenWallVariant = (tilesetId: string, position: number): number => pieces.get(tilesetId)?.get(position) ?? -1
